import React, { useState, useEffect } from "react";
import "./styles/main.scss";
import { translations } from "./components/translations";
import { ArrowUp } from "lucide-react"; // Uvoz ikone
import Navbar from "./components/Navbar";
import HomeMain from "./components/HomeMain";
import OurStory from "./components/OurStory";
import RSVPForm from "./components/RSVPForm";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";

function App() {
  const [lang, setLang] = useState("hr");
  const [showScrollBtn, setShowScrollBtn] = useState(false);

  const t = translations[lang];

  // Logika za prikazivanje gumba na skrol
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowScrollBtn(true);
      } else {
        setShowScrollBtn(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Funkcija za skrolanje na vrh
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="App">
      <Navbar lang={lang} setLang={setLang} t={t} />

      <HomeMain t={t} />
      <OurStory t={t} />

      <section id="rsvp">
        <RSVPForm t={t} />
      </section>

      <Gallery t={t} />
      <Contact t={t} />

      {/* Scroll to Top Gumb */}
      <button
        className={`scroll-to-top ${showScrollBtn ? "visible" : ""}`}
        onClick={scrollToTop}
        aria-label="Scroll to top"
      >
        <ArrowUp size={24} strokeWidth={1.5} />
      </button>
    </div>
  );
}

export default App;
